import { createClient } from '@supabase/supabase-js';

// Coloque aqui a URL e a chave anônima (pública) do seu projeto
const SUPABASE_URL = 'https://ihbbetzsxbqyovecbqqm.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImloYmJldHpzeGJxeW92ZWNicXFtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY3NDc2OTcsImV4cCI6MjA3MjMyMzY5N30.tzIzc9Sdg7Qh11RoOoGDb-ZjVlOBQWqBytIrUEMGqFE';

// Cria o cliente Supabase com persistência de sessão habilitada
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY, {
  auth: {
    persistSession: true,       // Mantém a sessão salva no navegador
    autoRefreshToken: true,     // Atualiza o token automaticamente quando expira
    detectSessionInUrl: true,   // Detecta a sessão no retorno do login
  },
});
